import { render, staticRenderFns } from "./coperiade.vue?vue&type=template&id=29af4ac5&"
import script from "./coperiade.vue?vue&type=script&lang=js&"
export * from "./coperiade.vue?vue&type=script&lang=js&"
import style0 from "./coperiade.vue?vue&type=style&index=0&id=29af4ac5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports